import { signInWithRedirect } from 'aws-amplify/auth'
import rhythmicLogo from '../assets/rhythmic-logo.svg'

function Login() {
  async function handleLogin() {
    // Redirect directly to Entra ID (skip hosted UI provider selection)
    await signInWithRedirect({ provider: { custom: 'EntraID' } })
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={rhythmicLogo} alt="Rhythmic Technologies" className="login-logo" />
        <h1>Rhythmic Dashboard</h1>
        <p>Sign in to access operational intelligence</p>
        <button className="btn btn-primary" onClick={handleLogin}>
          Sign in
        </button>
      </div>
    </div>
  )
}

export default Login
